





























































































import { Vue, Component, Mixins } from "vue-property-decorator";
import MyForm from "@/mixins/form";
import _ from "lodash";

@Component
export default class extends Mixins(MyForm) {
  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            // console.log(values)
            const res = await this.$store.dispatch("stadium/settlementAddItem", {
              ...values
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success("保存成功");

              this.handleCancel();
            } else {
              this.$message.error("保存失败");
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }
}
